



import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Tab,
  Tabs,
  Grid,
  Paper,
  Tooltip,
  useTheme,
  Modal,
  CircularProgress,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions
} from "@mui/material";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SendIcon from '@mui/icons-material/Send';
import { useNavigate } from "react-router-dom";
import api from "../../api/axiosInterceptor";
import { API_BASE_URL } from "../../config";
import { LoadingSpinner } from "../../Components/spinner/spinner";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";
import BaseInfoComponent from "./baseInfo";
import AfidavitCustComponent from "./afidavitComponent";
import NomineeInfoSection from "./nomineeComponent";
import LegalHeirInfoSection from "./legalHeirSection";
import InvestmentsSection from "./investmentComponent";
import LoansSection from "./loanComponent";
import ReturnedSection from "./returnedSection";
import RefundBankSection from "./refundBankSection";
import DepositedBanksSection from "./depositedBanksSection";
import FeBanksSection from "./feBankSection";
import { InstructionsModal } from "./instructionModalPop";
import { InstructionCheckbox } from "./instructionModal";
import { useFormik } from "formik";
import TotalsSection from "./claimTotal";
import ClaimPreview from "./claimPreview";
import { useTranslation } from "react-i18next"; // Correct import
import EkycComponent from "./eKycComponent";


// Utility empty objects for dynamic fields
const emptyDeposited = () => ({
  acc_no: "",
  bank_name: "",
  branch_name: "",
  ifsc_code: "",
  date_of_deposit: "",
  deposted_amt: "",
  particulars: "",
  remark: "",
  client_id: "",
  mode_of_payment: "",
  type_of_scheme: "",
  statement_doc: null,
});
// const emptyFeBank = () => ({
//   acc_no: "",
//   bank_name: "",
//   branch_name: "",
//   ifsc_code: "",
//   date_of_recieved: "",
//   recieved_amt: "",
//   particulars: "",
//   mode_of_payment: "",
//   remark: "",
//   proof_doc: null,
// });
const emptyInvestment = () => ({
  inv_account_no: "",
  inv_ifsc_code: "",
  inv_bank_name: "",
  inv_branch_name: "",
  inv_mode_of_payment: "",
  inv_scheme: "",
  inv_amt: "",
  inv_proof: null,
});
const emptyLoan = () => ({
  loan_account_no: "",
  loan_amt_borrowed: "",
  loan_amt_paid: "",
  loan_amt_remaining: "",
  loan_closed_date: "",
  loan_proof: null,
});
const emptyReturned = () => ({
  returned_account_no: "",
  returned_ifsc_code: "",
  returned_bank_name: "",
  returned_branch_name: "",
  returned_mode_of_payment: "",
  returned_scheme: "",
  returned_amt: "",
  returned_proof: null,
});


const accountTypes = [
  { value: "individual", label: "Individual" },
  { value: "joint", label: "Joint" },
  { value: "partnership", label: "Partnership" },
  { value: "trust", label: "Trust" },
  { value: "society", label: "Society" },
];


const claimentTypes = [
  { value: "self", label: "Self" },
  { value: "nominee", label: "Nominee" },
  { value: "legal_heir", label: "Legal Heir" },
];


export default function ClaimFormPage({ onSuccess }) {
  const { t, i18n } = useTranslation(); // Correct usage here
  const theme = useTheme();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [feOptions, setFeOptions] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
  const [instructionsChecked, setInstructionsChecked] = useState(false);
  const [instructionsModalOpen, setInstructionsModalOpen] = useState(false);
  const [instructionsError, setInstructionsError] = useState(false);


  const [base, setBase] = useState({
    ca_designation: "",
    fe_name: "",
    fe_code: "",
    is_normal: false,
    is_delayed: false,
    account_type: "",
    claiment_type: "",
    name_of_claimant1: "",
    name_of_claimant2: "",
    father_husband_name: "",
    photo: null,
    address: "",
    date_of_birth: "",
    ph_no: "",
    alt_ph_no: "",
    email_1: "",
    email_2: "",
    pan_no: "",
    pan_doc: null,
    ekyc_doc: null,
    relation_with_owner: "",
    txn_no: "",
  });


  const [affidavit, setAffidavit] = useState({ doc1: null });
  const [cust, setCust] = useState({ cust_id: "", doc: null });


  const [nominee, setNominee] = useState({
    nominee_name: "",
    nominee_gender: "",
    rel_with_depositor: "",
    nominee_death_cert: null,
    nominee_family_tree: null,
    nominee_ekyc_doc: null,
    nominee_pan_doc: null,
    nominee_nomination_proof: null,
  });


  const [total, setTotal] = useState({
    total_deposited: "",
    total_received: "",
    total_loan: "",
    total_claim: "",
  });


  const [legalHeir, setLegalHeir] = useState({
    legal_heir_name: "",
    legal_heir_gender: "",
    legal_heir_relation_with_depositor: "",
    legal_heir_death_certificate: null,
    legal_heir_family_tree: null,
    legal_heir_pan_doc: null,
    legal_heir_ekyc: null,
    legal_heir_letter_of_disclosure: null,
  });


  const [refundBank, setRefundBank] = useState({
    holder_name: "",
    // rel_with_nominee: "",
    acc_no: "",
    bank_name: "",
    branch_name: "",
    ifsc_code: "",
    refund_front_sheet: null,
  });


  const [depositedBanks, setDepositedBanks] = useState([emptyDeposited()]);
  // const [feBanks, setFeBanks] = useState([emptyFeBank()]);


  const [investments, setInvestments] = useState([emptyInvestment()]);
  const [loans, setLoans] = useState([emptyLoan()]);
  const [returneds, setReturneds] = useState([emptyReturned()]);
  const [totalReturned, setTotalReturned] = useState(0);
  const [totalRemaining, setTotalRemaining] = useState(0);
  const [totalInvestment, setTotalInvestment] = useState(0);
  const [claimantType, setClaimantType] = useState("");
  const [confirmSubmitOpen, setConfirmSubmitOpen] = useState(false);

  const handleTotalAmountChange = (total) => {
    setTotalInvestment(total);
  };


  const handleTotalRemainingChange = (total) => {
    setTotalRemaining(total);
  };



  const handleClaimantTypeChange = (type) => {
    setClaimantType(type);
    setBase((prev) => ({ ...prev, claiment_type: type }));
  };



  const handleTotalChange = (total) => {
    setTotalReturned(total);
  };


  // Extract distinct schemes from investments
  const schemeOptions = React.useMemo(() => {
    const schemes = investments.map(inv => inv.inv_scheme).filter(s => s);
    return Array.from(new Set(schemes));
  }, [investments]);


  useEffect(() => {
    fetchFeList();
  }, []);


  useEffect(() => {
    setTotal({
      total_deposited: totalInvestment,
      total_received: totalReturned,
      total_loan: totalRemaining,
      total_claim:
        (Number(totalInvestment) || 0) -
        (Number(totalRemaining) || 0) -
        (Number(totalReturned) || 0),
    });
  }, [totalInvestment, totalRemaining, totalReturned]);


  async function fetchFeList() {
    try {
      const res = await api.get(`/fe-mgmt/get-fe/`);
      console.log("FE List:", res.data);
      setFeOptions(res.data || []);
    } catch (err) {
      console.error(err);
      show("Failed to load FE list", "error");
    }
  }


  const show = (message, severity = "info") => setSnackbar({ open: true, message, severity });
  const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, open: false }));


  const handleInputChange = (setter) => (e) => {
    const { name, value, files, type, checked } = e.target;
    if (type === "checkbox") {
      setter((prev) => ({ ...prev, [name]: checked }));
      return;
    }
    if (files) {
      setter((prev) => ({ ...prev, [name]: files[0] }));
      return;
    }
    setter((prev) => ({ ...prev, [name]: value }));
  };


  const onFeSelect = (e) => {
    const val = e.target.value;
    const fe = feOptions.find((x) => x.fe_name === val);
    if (!fe) return;
    setBase((b) => ({
      ...b,
      fe_name: fe.fe_name,
      ca_designation: fe.ca_designation,
      fe_code: fe.fe_code,
      is_normal: !!fe.is_normal,
      is_delayed: !!fe.is_delayed,
    }));
  };


  // Helper: Append only non-empty keys to FormData
  const appendNonEmptyToFormData = (formData, obj, prefix = "") => {
    Object.entries(obj).forEach(([k, v]) => {
      if (
        v !== null &&
        v !== undefined &&
        !(typeof v === "string" && v.trim() === "")
      ) {
        formData.append(prefix + k, v);
      }
    });
  };


  // Helper: Clean arrays by filtering out empty objects
  const cleanArray = (arr) =>
    arr.filter((obj) =>
      Object.values(obj).some(
        (v) => v !== null && v !== undefined && !(typeof v === "string" && v.trim() === "")
      )
    );


  // For preview JSON: clone and prune empty keys
  const pruneEmpty = (obj) =>
    Object.fromEntries(
      Object.entries(obj).filter(
        ([_, v]) => v !== null && v !== undefined && !(typeof v === "string" && v.trim() === "")
      )
    );


  const gatherJSON = () => ({
    base: pruneEmpty(base),
    affidavit: affidavit.doc1 ? { doc1: affidavit.doc1.name } : {},
    cust: cust.cust_id || cust.doc ? { ...pruneEmpty(cust), doc: cust.doc ? cust.doc.name : null } : {},
    nominee: pruneEmpty(nominee),
    legalHeir: pruneEmpty(legalHeir),
    refundBank: pruneEmpty(refundBank),
    depositedBanks: cleanArray(depositedBanks).map(pruneEmpty),
    // feBanks: cleanArray(feBanks).map(pruneEmpty),
    investments: cleanArray(investments).map(pruneEmpty),
    loans: cleanArray(loans).map(pruneEmpty),
    returneds: cleanArray(returneds).map(pruneEmpty),
    total,
  });


  const formik = useFormik({
    initialValues: { instructionsChecked: false },
    validate: (values) => {
      const errors = {};
      if (!values.instructionsChecked) errors.instructionsChecked = "You must agree to the instructions";
      return errors;
    },
    onSubmit: () => {
      setActiveTab(activeTab + 1);
    },
  });


  const handleSubmit = async () => {
    const payload = new FormData();
    appendNonEmptyToFormData(payload, base);
    if (affidavit.doc1) payload.append("affidavit_doc1", affidavit.doc1);
    if (cust.cust_id) payload.append("cust_id", cust.cust_id);
    if (cust.doc) payload.append("cust_doc", cust.doc);
    appendNonEmptyToFormData(payload, nominee);
    appendNonEmptyToFormData(payload, legalHeir);
    appendNonEmptyToFormData(payload, refundBank);
    appendNonEmptyToFormData(payload, total);

    cleanArray(depositedBanks).forEach((b, idx) =>
      Object.entries(b).forEach(([k, v]) => {
        if (v !== null && v !== undefined && !(typeof v === "string" && v.trim() === ""))
          payload.append(`claim_deposited_bank_base[${idx}][${k}]`, v);
      })
    );
    // cleanArray(feBanks).forEach((b, idx) =>
    //   Object.entries(b).forEach(([k, v]) => {
    //     if (v !== null && v !== undefined && !(typeof v === "string" && v.trim() === ""))
    //       payload.append(`claim_fe_bank_base[${idx}][${k}]`, v);
    //   })
    // );
    cleanArray(investments).forEach((b, idx) =>
      Object.entries(b).forEach(([k, v]) => {
        if (v !== null && v !== undefined && !(typeof v === "string" && v.trim() === ""))
          payload.append(`claim_investment_base[${idx}][${k}]`, v);
      })
    );
    cleanArray(loans).forEach((b, idx) =>
      Object.entries(b).forEach(([k, v]) => {
        if (v !== null && v !== undefined && !(typeof v === "string" && v.trim() === ""))
          payload.append(`claim_loan_base[${idx}][${k}]`, v);
      })
    );
    cleanArray(returneds).forEach((b, idx) =>
      Object.entries(b).forEach(([k, v]) => {
        if (v !== null && v !== undefined && !(typeof v === "string" && v.trim() === ""))
          payload.append(`claim_returned_base[${idx}][${k}]`, v);
      })
    );



    try {
      setUploading(true);
      const response = await api.post(`/claim-mgmt/claims/`, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      show("Claim submitted successfully", "success");


      // Notify parent with ack_no from response data
      if (typeof onSuccess === "function") onSuccess(response.data.ack_no);


    } catch (err) {
      console.error(err);
      show("Failed to submit claim", "error");
    } finally {
      setUploading(false);
    }
  };


  const handleInstructionLinkClick = (e) => {
    e.preventDefault();
    setInstructionsModalOpen(true);
  };


  const handleTabChange = (event, newValue) => {
    if (!instructionsChecked && newValue !== 0) {
      setInstructionsError(true);
      show("Please read and agree to the instructions first.", "warning");
      return;
    }
    setInstructionsError(false);
    setActiveTab(newValue);
  };


  // const tabs = [
  //   { label: "Instructions" },
  //   { label: "Depositor Info" },
  //   { label: "Customer Details" },
  //   { label: "Nominee", show: base.claiment_type !== "legal_heir" },
  //   { label: "Legal Heir", show: base.claiment_type === "legal_heir" },
  //   { label: "Investment" },
  //   { label: "Deposited Details" },
  //   { label: "Loan" },
  //   { label: "Returned" },
  //   { label: "Summary" },
  //   { label: "Refund Bank" },
  //   // { label: "FE Banks" },
  //   { label: "Submit" },
  // ];


  const tabs = [
      { label: t("tabs.instructions") },
      { label: t("tabs.adhaarTab") },
      { label: t("tabs.depositorInfo") },
      { label: t("tabs.customerDetails") },
      { label: t("tabs.nominee"), show: base.claiment_type !== "legal_heir" },
      { label: t("tabs.legalHeir"), show: base.claiment_type === "legal_heir" },
      { label: t("tabs.investment") },
      { label: t("tabs.depositedDetails") },
      { label: t("tabs.loan") },
      { label: t("tabs.returned") },
      { label: t("tabs.summary") },
      { label: t("tabs.refundBank") },
      // { label: t("tabs.feBanks") },
      { label: t("tabs.submit") },
    ];



  const visibleTabs = tabs.filter((t) => t.show !== false);


  if (loading) return <LoadingSpinner />;


  return (
    <Box
      sx={{
        p: { xs: 2, sm: 4 },
        mt: 10,
        mb: 8,
        maxWidth: 1100,
        mx: "auto",
        bgcolor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        borderRadius: 3,
      }}
      component={Paper}
      elevation={8}
    >
      {/* <Button
        variant="outlined"
        onClick={() => navigate(-1)}
        startIcon={<NavigateBeforeIcon />}
        sx={{ mb: 2, fontWeight: 600 }}
      >
        Back
      </Button> */}
      <Typography
        variant="h4"
        mb={3}
        sx={{ fontWeight: "700", textAlign: "center", color: theme.palette.primary.main }}
      >
        Claim Application
      </Typography>


      <Tabs
        key={i18n.language}  // Key to remount tabs on language change
        value={activeTab}
        onChange={handleTabChange}
        aria-label="claim-tabs"
        sx={{
          mb: 3,
          "& .MuiTabs-indicator": {
            height: 4,
            borderRadius: "4px 4px 0 0",
            backgroundColor: theme.palette.primary.main,
            transition: "all 0.3s ease",
          },
          "& .MuiTab-root": {
            borderRadius: 1,
            textTransform: "none",
            color: theme.palette.text.secondary,
            fontWeight: 600,
            mx: 0.7,
            px: 2.5,
            fontSize: "1rem",
            minWidth: 120,
            transition: "color 0.3s ease",
          },
          "& .Mui-selected": {
            color: theme.palette.primary.main,
            fontWeight: "bold",
            backgroundColor: theme.palette.action.hover,
          },
          "& .MuiTab-root:hover": {
            color: theme.palette.primary.dark,
            opacity: 1,
          },
        }}
        variant="scrollable"
        scrollButtons="auto"
      >
        {visibleTabs.map((t, idx) => (
          <Tab key={`${i18n.language}-${idx}`} label={t.label} disabled={!instructionsChecked && idx !== 0} />
        ))}
      </Tabs>


      {visibleTabs[activeTab].label === t("tabs.instructions") && (
        <Box>
          <InstructionCheckbox
            instructionsChecked={instructionsChecked}
            setInstructionsChecked={setInstructionsChecked}
            handleInstructionLinkClick={handleInstructionLinkClick}
            error={instructionsError}
            formik={formik}
          />
        </Box>
      )}


      


      <InstructionsModal
        instructionsModalOpen={instructionsModalOpen}
        setInstructionsModalOpen={setInstructionsModalOpen}
        handleInstructionsAgree={() => {
          setInstructionsChecked(true);
          setInstructionsModalOpen(false);
        }}
      />


      {visibleTabs[activeTab].label === t("tabs.adhaarTab") && (
        // <EkycComponent
        //   onNext={() => setActiveTab(activeTab + 1)}
        //   onBack={() => setActiveTab(activeTab - 1)}
        //   onShowError={(msg) => show(msg, "error")}
        // />

        <EkycComponent
  onNext={() => setActiveTab(activeTab + 1)}
  onBack={() => setActiveTab(activeTab - 1)}
  onShowError={(msg) => show(msg, "error")}
  onTxnNo={(txnNo) =>
    setBase((prev) => ({
      ...prev,
      txn_no: txnNo,
    }))
  }
/>
      )}


      {visibleTabs[activeTab].label === t("tabs.depositorInfo") && (
        <BaseInfoComponent
          base={base}
          feOptions={feOptions}
          onFeSelect={onFeSelect}
          accountTypes={accountTypes}
          claimentTypes={claimentTypes}
          handleInputChange={handleInputChange}
          setBase={setBase}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          onClaimantTypeChange={handleClaimantTypeChange}
        />
      )}


      {visibleTabs[activeTab].label === t("tabs.customerDetails") && (
        <AfidavitCustComponent
          handleInputChange={handleInputChange}
          setAffidavit={setAffidavit}
          affidavit={affidavit}
          cust={cust}
          setCust={setCust}
          base={base}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          setBase={setBase}
        />
      )}


      {visibleTabs[activeTab].label === t("tabs.nominee") && (
        <NomineeInfoSection
          nominee={nominee}
          handleInputChange={handleInputChange}
          setNominee={setNominee}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          clType={claimantType}
        />
      )}


      {visibleTabs[activeTab].label === t("tabs.legalHeir") && (
        <LegalHeirInfoSection
          legalHeir={legalHeir}
          handleInputChange={handleInputChange}
          setLegalHeir={setLegalHeir}
          activeTab={activeTab}
          setActiveTab={setActiveTab}


        />
      )}


      {visibleTabs[activeTab].label === t("tabs.investment") && (
        <InvestmentsSection
          FE={base.fe_name}
          investments={investments}
          setInvestments={setInvestments}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          onTotalAmountChange={handleTotalAmountChange}
        />
      )}


      {visibleTabs[activeTab].label === t("tabs.depositedDetails") && (
        <DepositedBanksSection
          depositedBanks={depositedBanks}
          setDepositedBanks={setDepositedBanks}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          totalInvestment={totalInvestment}
          schemeOptions={schemeOptions}
          investments={investments} 
        />
      )}


      {visibleTabs[activeTab].label === t("tabs.loan") && (
        <LoansSection
          loans={loans}
          setLoans={setLoans}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          onTotalRemainingChange={handleTotalRemainingChange}
        />
      )}


      {visibleTabs[activeTab].label === t("tabs.returned") && (
        <ReturnedSection
          returneds={returneds}
          setReturneds={setReturneds}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          onTotalChange={handleTotalChange}
          schemeOptions={schemeOptions}
          investments={investments} 
        />
      )}


      {visibleTabs[activeTab].label === t("tabs.summary") && (
        <TotalsSection
          total={total}
          handleInputChange={handleInputChange}
          setTotal={setTotal}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          investments={totalInvestment}
          loans={totalRemaining}
          returneds={totalReturned}
        />
      )}


      {visibleTabs[activeTab].label === t("tabs.refundBank") && (
        <RefundBankSection
          refundBank={refundBank}
          handleInputChange={handleInputChange}
          setRefundBank={setRefundBank}
          base={base}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          setBase={setBase}
        />
      )}



       {/*


      {visibleTabs[activeTab].label === "FE Banks" && (
        <FeBanksSection
          feBanks={feBanks}
          setFeBanks={setFeBanks}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      )} */}


      {/* {visibleTabs[activeTab].label === "Submit" && (
        <Box>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: theme.palette.text.primary, fontWeight: 700, mb: 2 }}
          >
            PREVIEW
          </Typography>
          <Box
            sx={{
              whiteSpace: "pre-wrap",
              bgcolor: "#fafafa",
              p: 3,
              borderRadius: 2,
              mb: 3,
              maxHeight: 420,
              overflow: "auto",
              fontFamily: "Roboto Mono, monospace",
              fontSize: "0.9rem",
              boxShadow: theme.shadows[1],
              border: `1px solid ${theme.palette.divider}`,
              "&::-webkit-scrollbar": {
                width: 8,
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: theme.palette.primary.light,
                borderRadius: 4,
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#eee",
                borderRadius: 4,
              },
            }}
          >
            {JSON.stringify(gatherJSON(), null, 2)}
          </Box>


          <Grid container spacing={2} justifyContent="space-between">
            <Grid item>
              <Tooltip title="Previous Tab">
                <span>
                  <Button
                    variant="outlined"
                    color="secondary"
                    startIcon={<NavigateBeforeIcon />}
                    disabled={activeTab === 0}
                    onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}
                    sx={{ fontWeight: 600, px: 3 }}
                  >
                    Back
                  </Button>
                </span>
              </Tooltip>
            </Grid>


            <Grid item>
              <Tooltip title="Submit your claim">
                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<SendIcon />}
                  onClick={handleSubmit}
                  sx={{
                    px: 3,
                    fontWeight: 700,
                    textTransform: "none",
                    boxShadow: `0 4px 12px ${theme.palette.primary.main}80`,
                    transition: "transform 0.2s ease",
                    "&:hover": {
                      transform: "scale(1.05)",
                      boxShadow: `0 8px 24px ${theme.palette.primary.dark}cc`,
                    },
                  }}
                  disabled={uploading}
                >
                  Submit Claim
                </Button>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )} */}



      {visibleTabs[activeTab].label === t("tabs.submit") && (
        <Box>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ color: theme.palette.text.primary, fontWeight: 700, mb: 2 }}
          >
            Preview Your Claim Details
          </Typography>


          <ClaimPreview data={gatherJSON()} />


          <Grid container spacing={2} justifyContent="space-between" sx={{ mt: 3 }}>
            <Grid item>
              <Button
                variant="outlined"
                color="secondary"
                startIcon={<NavigateBeforeIcon />}
                onClick={() => setActiveTab(activeTab - 1)}
                sx={{ fontWeight: 600 }}
              >
                Back
              </Button>
            </Grid>
            <Grid item>
              {/* <Button
                    variant="contained"
                    color="primary"
                    endIcon={<SendIcon />}
                    onClick={handleSubmit}
                    disabled={uploading}
                    sx={{ fontWeight: 700 }}
                  >
                    Submit Claim
                  </Button> */}


              <Button
                variant="contained"
                color="primary"
                endIcon={<SendIcon />}
                onClick={() => setConfirmSubmitOpen(true)}
                disabled={uploading}
                sx={{ fontWeight: 700 }}
              >
                Submit Claim
              </Button>


            </Grid>
          </Grid>
        </Box>
      )}


      <SnackBarComponent
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={closeSnackbar}
      />



      <Dialog
        open={confirmSubmitOpen}
        onClose={() => setConfirmSubmitOpen(false)}
        aria-labelledby="confirm-submit-dialog-title"
        aria-describedby="confirm-submit-dialog-description"
      >
        <DialogTitle id="confirm-submit-dialog-title">Confirm Submission</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-submit-dialog-description">

            {t("tabs.confirmation")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmSubmitOpen(false)} color="secondary">
            {t("tabs.cancel")}
          </Button>
          <Button
            onClick={() => {
              setConfirmSubmitOpen(false);
              handleSubmit();
            }}
            color="primary"
            autoFocus
          >
            {t("tabs.submit1")}
          </Button>
        </DialogActions>
      </Dialog>


      <Modal
        open={uploading}
        aria-labelledby="uploading-modal-title"
        aria-describedby="uploading-modal-description"
        closeAfterTransition
        disableEscapeKeyDown
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            width: 320,
            textAlign: "center",
            outline: "none",
          }}
        >
          <CircularProgress color="primary" size={60} sx={{ mb: 3 }} />
          <Typography variant="h6" id="uploading-modal-title" gutterBottom>
             {t("tabs.bufMsg1")}<br />{t("tabs.bufMsg2")}
          </Typography>
        </Box>
      </Modal>
    </Box>
  );
}

